import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateTicketType } from '../../api/TICKET/ticketMeta';
import { toast } from 'react-toastify';

export const useUpdateTicketType = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ typeId, typeData }) => updateTicketType(typeId, typeData),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['ticket-types'] });
            toast.success('Type de ticket modifié avec succès');
        },
        onError: (error) => {
            toast.error(error.message || 'Erreur lors de la modification du type de ticket');
        },
    });
};
